// What each person has agreed to. Everything VERA reads or does beyond answering questions is opt-in, per person,
// and can be changed at any time in "Privacy & consent".
// Kept on this device and, with live VERA, on the server too, so the choices follow the person to any device (history.ts).

import { settingsChanged } from "./history";

export const CONSENT_VERSION = "2026-10-09";

export type Consent = {
  version: string;
  at: string;              // when the person last confirmed (ISO time)
  terms: boolean;          // required: understands how VERA works, agrees to the terms and privacy policy
  folders: boolean;        // VERA may read folders the person adds on this computer, when they ask
  m365: boolean;           // VERA may read email, calendar and Teams once they connect them
  mic: boolean;            // microphone for voice, only while voice is on
};

export const NO_CONSENT: Consent = { version: "", at: "", terms: false, folders: false, m365: false, mic: false };

const key = (userId: string) => `vera-consent-${userId}`;

export function loadConsent(userId: string): Consent {
  try {
    const raw = localStorage.getItem(key(userId));
    if (raw) return { ...NO_CONSENT, ...(JSON.parse(raw) as Partial<Consent>) };
  } catch { /* ignore */ }
  return NO_CONSENT;
}

export function saveConsent(userId: string, c: Omit<Consent, "version" | "at">): Consent {
  const full: Consent = { ...c, version: CONSENT_VERSION, at: new Date().toISOString() };
  try { localStorage.setItem(key(userId), JSON.stringify(full)); } catch { /* ignore */ }
  settingsChanged();
  return full;
}

/** The person needs to (re)confirm when they never agreed, or the wording changed since. */
export const needsConsent = (c: Consent) => !c.terms || c.version !== CONSENT_VERSION;
